import { render, staticRenderFns } from "./AccessView.vue?vue&type=template&id=32d9503b&scoped=true&"
import script from "./AccessView.vue?vue&type=script&lang=js&"
export * from "./AccessView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9503b",
  null
  
)

export default component.exports